/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User/ExternalProfessionalInfo/Content"
  
}) {
let userExternalProfessionalInfoValueData = fromData.useDataValue({ viewPath,
context: 'user',
path: 'external_professional_info',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral700}
 data="user.external_professional_info"
 text={userExternalProfessionalInfoValueData}
/>
{children}
</React.Fragment>)
}